import { render, staticRenderFns } from "./PagamentoForm.vue?vue&type=template&id=33dff1d4"
import script from "./PagamentoForm.vue?vue&type=script&lang=js"
export * from "./PagamentoForm.vue?vue&type=script&lang=js"
import style0 from "./PagamentoForm.vue?vue&type=style&index=0&id=33dff1d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports